import { useOrganizationUnits } from '@/features/organization-units/public';
import { MEMBER_ROLES } from '../types';

/**
 * Aggregates catalog data needed by the members table:
 * - `areas`: list of organization units mapped to `{ id, name, color }`, shared cache with the org-units tree
 * - `roles`: constant array derived from `MEMBER_ROLES` (no API endpoint)
 *
 * @remarks
 * Areas are fetched via `useOrganizationUnits` to share the TanStack Query cache
 * with the organization-units feature — a single GET /api/tenants/areas is issued
 * regardless of how many components consume this hook.
 *
 * @example
 * const { areas, roles, isLoading } = useMemberCatalogs();
 */
export function useMemberCatalogs() {
  const { data: units, isLoading, isError } = useOrganizationUnits();

  const areas = (units ?? []).map(({ id, name, color }) => ({ id, name, color }));

  return {
    areas,
    roles: MEMBER_ROLES,
    isLoading,
    isError,
  };
}
